import { render } from "./ScrollTop.vue?vue&type=template&id=0fbb1a5c"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"

import "./ScrollTop.vue?vue&type=style&index=0&id=0fbb1a5c&lang=scss"
script.render = render

export default script